import { render, staticRenderFns } from "./IncidentCard.vue?vue&type=template&id=08ef785c&"
import script from "./IncidentCard.vue?vue&type=script&lang=js&"
export * from "./IncidentCard.vue?vue&type=script&lang=js&"
import style0 from "./IncidentCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports